import * as React from 'react';
import Enconstruccion from '../../../componentes/herramientas/pantallas/enconstruccion';
export default function Administrativo() {
    return (<Enconstruccion />)
}